'use strict';
import get from 'lodash/get';
import 'rxjs/add/observable/combineLatest';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/map';
import {getCollection, getId, getLink} from '../../core-utilities/domain/ReduxUtils';
import {canStartTimer} from '../../tasks/domain/utils';
import {startTimer} from '../../timers/actions';
import {TaskInfoTimerController} from '../../timers/controllers/TaskInfoTimerController';
import {findAllByTarget} from '../../timers/reducers/activeTimersReducers';
import {getActiveTimers} from '../../timers/reducers/state';
import {autoPrioritiesListActions, pinnedPrioritiesListActions} from '../actions';
import {targetIsTask} from '../domain/utils';
import {USER_PRIORITY} from '../enums/USER_PRIORITIES';


UserHomeController.$inject = [
  '$scope',
  '$contextMenu',
  '$ngRedux',
  'appNavigatorService',
];

export function UserHomeController(
  $scope,
  $contextMenu,
  $ngRedux,
  appNavigatorService,
) {
  const vm = $scope.userHome = this;

  vm.viewProps = {
    onClickItem: (e, model) => goToTarget(model),
    onItemContextMenu: (e, model) => openItemContextMenu(model),
  };

  function openItemContextMenu(pin) {
    const actions = [];

    if (pin && targetIsTask(pin.target) && canStartTimer(get(pin, 'target.status'))) {
      const rootState = $ngRedux.getState();
      const activeTimers = getActiveTimers(rootState).list;
      const existingItems = findAllByTarget(getCollection(pin.target), getId(pin.target), activeTimers);

      if (existingItems.length === 0) {
        actions.push({messageId: 'user.home.timer.start.label', action: startTaskTimer.bind(vm, pin)});
      }
    }

    actions.push({messageId: 'user.home.priorities.remove.label', action: removePin.bind(vm, pin)});

    // console.log('showing menu for ', pin)
    $contextMenu.show({
      titleMessageId: 'default.options.context.title.label',
      titleMessageParams: {name: 'Pin'},
      cancelMessageId: 'defaults.context.cancel.label',
      actions,
    });
  }

  function startTaskTimer(pin) {
    const payload = TaskInfoTimerController.buildStartTimerPayload(pin.target, get(pin, 'metadata.parentName'));
    if (payload) {
      $ngRedux.dispatch(startTimer(payload));
    }
  }

  function removePin(pin) {
    switch (pin.priority) {
      case USER_PRIORITY.AUTO_PINNED:
        $ngRedux.dispatch(autoPrioritiesListActions.deleteItem({id: getId(pin)}));
        break;
      case USER_PRIORITY.PINNED:
      default:
        // TODO: should probably dispatch a dedicated action for deleting any other values
        $ngRedux.dispatch(pinnedPrioritiesListActions.deleteItem({id: getId(pin)}));
    }
  }

  // TODO(nav): Fix missing back button when going to pin target
  // See issue https://github.com/driftyco/ionic/issues/437
  function goToTarget(pin) {
    const targetLink = getLink(pin, 'target');
    if (targetLink) {
      return appNavigatorService.goToLink(targetLink);
    } else {
      // TODO: should probably show toast
      return Promise.resolve(null);
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/priorities/controllers/UserHomeController.js